type Props = {
  color?: string;
};

export default function Clock({color = "var(--brand-primary-color)"}: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="7" stroke={color} strokeWidth="2" />
      <path
        d="M8 4.5V8.5H11.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
